import React from 'react'
import classnames from 'classnames'

import { useFloorState } from '../../../../firebase/hooks/useFloor'
import { useLastActiveMediaTrayCard } from '../../../../firebase/hooks/useTray'
import { useRole } from '../../../../global/blocs/roomInfo'
import { OnDemandPlayback } from '../../../../headless/src/components/on-demand-playback/on-demand-playback'
import { FloorHeadlessFeed } from '../FloorHeadlessFeed/FloorHeadlessFeed'
import { usePanelScreen } from '../../../../firebase/hooks/usePanel'

import { FloorTrayImage } from './FloorTrayImage/FloorTrayImage'

const FloorTrayFeed = () => {
  const lastActiveMediaCard = useLastActiveMediaTrayCard()
  const floor = useFloorState()
  const panelScreenState = usePanelScreen()
  const role = useRole()

  const isTrayFeedVisible =
    floor?.layout === 'tray' ||
    (floor?.layout === 'panel' && panelScreenState === 'tray')

  return (
    <div
      className={classnames('tray-track', {
        hide: !isTrayFeedVisible,
      })}
    >
      {lastActiveMediaCard?.type === 'image' && (
        <FloorTrayImage trayCard={lastActiveMediaCard} />
      )}

      {role === 'headless' ? (
        <OnDemandPlayback isVisible={lastActiveMediaCard?.type === 'video'} />
      ) : (
        <FloorHeadlessFeed isVisible={lastActiveMediaCard?.type === 'video'} />
      )}
    </div>
  )
}

export { FloorTrayFeed }
